import { z } from "zod";

/** `GET /api/health` — liveness for compose and Traefik, no dependencies checked. */
export const HealthResponse = z.object({
  status: z.literal("ok"),
  service: z.string(),
  version: z.string(),
});
export type HealthResponse = z.infer<typeof HealthResponse>;
